module.exports = __webpack_public_path__ + "4ec2176b03bf549122bb360ddea1f379.woff";